import { useBranding } from '@blimo/ui';

export const DEFAULT_APP_NAME = 'BLIMO Verwaltung';

/** "<Kurzname> Verwaltung" aus dem Laufzeit-Branding (Standard: BLIMO Verwaltung). */
export function useAppName() {
  const { short_name: shortName } = useBranding();
  return shortName ? `${shortName} Verwaltung` : DEFAULT_APP_NAME;
}
